import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import User from '../../singletons/User';
import { LOG } from '../../constants/routing';
import { observer } from 'mobx-react-lite';
import { Field, Formik } from 'formik';
import { TextField } from 'formik-material-ui';
import { makeStyles } from '@material-ui/core/styles';
import EntrySchema from '../../schemas/EntrySchema';
import { Button, Grid } from '@material-ui/core';

const defaultEntry = Object.freeze({
  from: '',
  userId: '',
  body: '',
});


const AddEntry = ({ postId, onCancel }) => {
  const classes = useStyles();

  const handleSubmit = useCallback(async (values, form) => {
    console.log('handleSubmit')
    const post = User.user?.posts?.getById(postId);
    await post?.logs?.addEntry(values);
    onCancel?.();
  }, []);

  const initialValues = useMemo(() => {
    return {
      ...defaultEntry,
      from: User.user?.firstName,
      userId: User.userId,
    };
  }, []);

  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={initialValues}
      validationSchema={EntrySchema}>
      {
        renderProps => {
          const { handleSubmit, values, isValid, dirty } = renderProps;
          return (
            <form className={classes.form} onSubmit={handleSubmit}>
              <Grid container spacing={3} justifyContent={'flex-end'}>
                <Grid item xs={12}>
                  <Field
                    fullWidth
                    variant={'outlined'}
                    label={'Body'}
                    value={values.body}
                    rows={16}
                    multiline={true}
                    component={TextField}
                    name={'body'}
                  />
                </Grid>
                <Grid item>
                  <Button
                    className={classes.cancel}
                    fullWidth
                    variant={'outlined'}
                    onClick={onCancel}>
                    Cancel
                  </Button>
                </Grid>
                <Grid item className={classes.container}>
                  <Button
                    fullWidth
                    className={classes.save}
                    variant={'contained'}
                    type={'submit'}
                    color={'primary'}
                    disabled={!isValid || !dirty}>
                    Save
                  </Button>
                </Grid>
              </Grid>
            </form>
          );
        }
      }
    </Formik>
  );
};

AddEntry.propTypes = {

};

const useStyles = makeStyles(

  theme => {
    return {
      form: {

      },
      save:  {
        color: 'white',
        flexGrow: 1,
      },
      container: {
        flex: 1,
      },
      cancel: {

      }
    };
  }
);

export default observer(AddEntry);
